import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Accesso effettuato");
      navigate("/admin");
    } else {
      toast.error(res.error || "Credenziali non valide");
    }
  };

  return (
    <div className="min-h-screen bg-cream grain flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid={ADMIN.loginForm}
        className="w-full max-w-md bg-white border border-line p-10 shadow-sm"
      >
        <p className="text-xs uppercase tracking-[0.3em] text-peach mb-4">— Area riservata</p>
        <h1 className="font-heading text-5xl tracking-tighter mb-10">Login.</h1>
        <div className="space-y-8">
          <div>
            <label className="block text-xs uppercase tracking-[0.22em] text-ink/60 mb-2">Email</label>
            <input
              data-testid={ADMIN.loginEmail}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-line-dark py-3 focus:outline-none focus:border-peach transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.22em] text-ink/60 mb-2">Password</label>
            <input
              data-testid={ADMIN.loginPassword}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-line-dark py-3 focus:outline-none focus:border-peach transition-colors"
            />
          </div>
          <button
            type="submit"
            data-testid={ADMIN.loginSubmit}
            disabled={loading}
            className="w-full bg-ink text-cream rounded-full py-4 text-xs uppercase tracking-[0.22em] hover:bg-peach transition-colors disabled:opacity-50"
          >
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </div>
      </form>
    </div>
  );
}
